<template>
  <div class="item">
    <div class="cover">
      <img :src="require(`@/assets/images/${image}`)" alt="Logo" />
    </div>
    <div class="about">
      {{ about }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Item",
  props: {
    image: {
      type: String,
      required: true
    },
    about: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.item {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
}

.cover {
  width: 140px;
  height: 140px;
  box-shadow: 0 15px 30px -8px rgba(0, 0, 0, 0.1);
  border-radius: 30%;
  padding: 25px;
  transition: all 0.25s ease;
}

.cover:hover {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  transform: translateY(7px);
}

.cover img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.about {
  padding: 5px;
}
</style>
